import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWorkPositionType } from "src/models/HumanResources/WorkPositionTypes.models";

interface WorkPositionTypeState {
  workPositionTypes: IWorkPositionType[];
  workPositionTypeToEdit: IWorkPositionType | null;
}

const initialState: WorkPositionTypeState = {
  workPositionTypes: [],
  workPositionTypeToEdit: null,
};

const WorkPositionTypeSlice = createSlice({
  name: "WorkPositionType",
  initialState,
  reducers: {
    setWorkPositionTypeList: (
      state,
      action: PayloadAction<IWorkPositionType[]>
    ) => {
      state.workPositionTypes = action.payload;
    },
    concatListWorkPositionType: (
      state: WorkPositionTypeState,
      action: PayloadAction<IWorkPositionType[]>
    ) => {
      state.workPositionTypes = [
        ...state.workPositionTypes.concat(action.payload),
      ];
    },
    setWorkPositionTypeToEdit: (
      state,
      action: PayloadAction<IWorkPositionType | null>
    ) => {
      state.workPositionTypeToEdit = action.payload;
    },
    addWorkPositionType: (state, action: PayloadAction<IWorkPositionType>) => {
      state.workPositionTypes.push(action.payload);
    },
    updateWorkPositionType: (
      state,
      action: PayloadAction<IWorkPositionType>
    ) => {
      let itemIndex = state.workPositionTypes.findIndex(
        item => item.workPositionTypeId === action.payload.workPositionTypeId
      );
      if (itemIndex !== -1) state.workPositionTypes[itemIndex] = action.payload;
    },
    deleteWorkPositionType: (state, action: PayloadAction<number>) => {
      const newArray = state.workPositionTypes.filter(
        item => item.workPositionTypeId !== action.payload
      );
      state.workPositionTypes = newArray;
    },
  },
});

export const {
  setWorkPositionTypeList,
  concatListWorkPositionType,
  setWorkPositionTypeToEdit,
  addWorkPositionType,
  updateWorkPositionType,
  deleteWorkPositionType,
} = WorkPositionTypeSlice.actions;

export default WorkPositionTypeSlice.reducer;
